import { combineReducers } from 'redux';
import signupReducer from './signupReducer';
import authReducer from './authReducer';
import profileReducer from './profileReducer';
import notificationsReducer from './notificationReducer'
import userDataReducer from './userdataReducer';
import localityReducer from './localityReducer';
import localityradiusReducer from './radiusReducer';

const rootReducer = combineReducers({
  signup: signupReducer,
  auth: authReducer,
  profile: profileReducer,
  notifications: notificationsReducer,
  userdata: userDataReducer,
  locality: localityReducer,
  radius: localityradiusReducer,
});

export default rootReducer;